// extracted by mini-css-extract-plugin
export default {"email":"Email_email__lHttv"};